<h1 mat-dialog-title class="columns-reorder-header aza-pa-dialog-title" translate>{{ data.translatableTitleString }}</h1>
<div mat-dialog-content class="aza-pa-dialog-content">
  <div class="reorder-container columns-to-display aza-pa-flex-column aza-pa-content-center">
    <div class="aza-cmp-flex-row">
      <azavista-button action="sort-alphabetically" (click)="sortAlphabetically()" color="primary">
        <mat-icon>sort_by_alpha</mat-icon>{{TRANSLATION_MAP.SORT_ALPHABETICALLY | translate}}
      </azavista-button>
      <azavista-button action="reverse-order" (click)="reverseOrder()" color="primary">
        <mat-icon>swap_vert</mat-icon>{{TRANSLATION_MAP.REVERSE | translate}}
      </azavista-button>
    </div>
    <div cdkDropList [cdkDropListData]="data.items" class="reorder-list aza-pa-border aza-cmp-rounded-border"
      (cdkDropListDropped)="drop($event)">
      @for (item of data.items; track item) {
        <div class="reorder-box drag-item aza-pa-flex-row aza-pa-border aza-pa-padding" cdkDrag>{{item.name}}</div>
      }
    </div>
  </div>
</div>
<div mat-dialog-actions class="aza-pa-dialog-actions">
  <azavista-flat-button action="cancel" (click)="onCancelClick()" color="primary" class="aza-pa-dialog-action-cancel-button"><span translate>CANCEL</span></azavista-flat-button>
  <azavista-button action="apply" (click)="onApplyClick()" color="primary" class="aza-pa-dialog-action-apply-button"><span translate>APPLY</span>
</azavista-button>
</div>
